import request from '../util/request';
export default {
  getProvinceList({ commit }) {
    request({
      url: 'open/statistic/reportData',
      data: {
        json: JSON.stringify({
          pageBean: {
            pageNum: 1,
            pageSize: 10000
          },
          params: {
            handlerName: 'region_province_list',
            parentId: 'CN'
          }
        })
      }
    }).then(res => {
      commit('setProvinceList', res.list);
    });
  },
  getCityList({ commit, state }) {
    request({
      url: 'open/statistic/reportData',
      data: {
        json: JSON.stringify({
          pageBean: {
            pageNum: 1,
            pageSize: 10000
          },
          params: {
            handlerName: 'region_province_list',
            parentId: ''
          }
        })
      }
    }).then(res => {
      commit('setCityList', res.list);
    });
  }
};
